module.exports = "<ol class=\"breadcrumbs\">\n    <li\n        ng-repeat=\"crumb in vm.items\"\n        class=\"step\"\n        ng-class=\"{ 'current': $last }\"\n    >\n        <a ng-if=\"crumb.state\" ui-sref=\"{{ crumb.state }}\">{{ crumb.label }}</a>\n        <span ng-if=\"!crumb.state\">{{ crumb.label }}</span>\n    </li>\n</ol>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/breadcrumbs/template.html
// module id = 1596
// module chunks = 0